export default {
  listView: 'vehicles',
  editView: 'vehicles-edit',
  documentsView: 'vehicles-documents',
};
